import {Component,Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InventoryService } from 'src/app/services/inventory.service';
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { Subject} from 'rxjs';
import { filter, share, switchMap, takeUntil } from 'rxjs/operators';
import { ShipmentSku } from "src/app/models/shipyard.model";
import { UpdateSkuQtyComponent } from "src/app/modules/shipyard/shipments-detail/update-sku-qty/update-sku-qty.component";
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { CreateItemComponent } from '../create-item/create-item.component';
import { MatAutocomplete } from '@angular/material/autocomplete';

@Component({
  selector: "app-add-item-dialog",
  templateUrl: "./add-item-dialog.component.html",
  styleUrls: ["./add-item-dialog.component.scss"],
})
export class AddItemDialogComponent implements OnInit, OnDestroy {
  selectedItems: any[] = [];
  form: FormGroup = new FormGroup({
    autocomplete: new FormControl(),
    qty: new FormControl(1, [Validators.required]),
    type: new FormControl('quantity')
  });
  filteredOptions$: any;
  validatedSku :boolean= false;
  vendorId: number;
  startRow : number = 0;
  amountPerPage:number = 10;
  startRowArray:any[]=[];
  private destroy$ = new Subject<void>();
  spin: boolean=false;
  @ViewChild('auto') public scroll!: MatAutocomplete;
  constructor(
    @Inject(MAT_DIALOG_DATA) public vendorName,
    public dialogRef: MatDialogRef<AddItemDialogComponent>,
    private dialog: MatDialog,
    private planyardService: PlanyardService,
    private inventoryService: InventoryService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form.get("autocomplete").valueChanges.pipe(
      filter(e => typeof e === 'string'),
      switchMap((value) =>{
        if(value){
          this.startRow=0;
          const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
          if(idx != -1){
            this.startRowArray['startrow_']=0
          }else{
            this.startRowArray['startrow_'] = 0;  
          }
          return this.planyardService.TypeaheadItem(value, this.vendorId, null,this.startRow,this.startRow + this.amountPerPage)
        } else{
          let e = [];
          return e;
        }
      }),
      share()
    ).subscribe((e)=>{
      this.filteredOptions$ = e;
      this.startRowArray['startrow_']+= this.amountPerPage;
    })


    // this should be replaced by a vendor ID returned by backend
    this.inventoryService.typeaheadVendor(this.vendorName.data).pipe(takeUntil(this.destroy$)).subscribe(e => this.vendorId = e[0].vendorId)
  }

  action(e) {
    if (e === "Confirm") {
      this.spin = true;
     const items=this.selectedItems.map(e => {
        return {
          vendorItemId: e.id,
          qty: e.qty,
          vendorItemName:e.title
        }
      });
      this.vendorName.callBackFn(this.dialogRef,items,this.spin);
    } else {
      this.dialogRef.close();
    }
  }

  displayWith(value: ShipmentSku) {
    if (value) {
      return value.title;
    }
  }

  updateQty(sku) {
    this.dialog
      .open(UpdateSkuQtyComponent, {
        data: {
          title: "Update Quantity",
          inputLabel: "New Quantity",
        },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {});
  }

  removeItem(item) {
    this.selectedItems = this.selectedItems.filter(currentItem => item.id !== currentItem.id);
  }

  insertInList(): void {
    const type=this.form.get('type').value;
    if (this.form.value.autocomplete.id) {
      this.selectedItems.push({...this.form.value.autocomplete, qty: type == 'quantity' ?  this.form.value.qty : (this.form.value.qty *  this.form.value.autocomplete.caseQty) || 0});
      this.form.reset();
      this.form.get("qty").setValue(1);
      this.form.get("type").setValue("quantity");
    } else {
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Please select valid vendor item',
              action: 'Dismiss',
              type: 'info',
            },
          }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  createItem(){
    this.dialog
    .open(CreateItemComponent, {
      width: "1100px",
      data:{
        vendorId: this.vendorId,
        Item: this.form.value.autocomplete,
        qty: this.form.value.qty,
        name:this.vendorName.data
      }
    })
    .afterClosed()
    .pipe()
    .subscribe((e) => {
      if(e) this.selectedItems.push(e);
      if(e?.res) this.filteredOptions$.push(...e.res);
    });
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop + event.target.offsetHeight == event.target.scrollHeight) {     
      const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
      if(idx != -1){
        this.startRow=this.startRowArray['startrow_'];
      }else{
        this.startRowArray['startrow_'] = 0; 
        this.startRow=0;
      }
      const value= this.form.get("autocomplete").value;
      this.startRowArray['startrow_']+= this.amountPerPage;
      return this.planyardService.TypeaheadItem(value, this.vendorId, null,this.startRow,this.startRow + this.amountPerPage).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
       this.filteredOptions$.push(...res);
      });
    }
  } 
  registerPanelScrollEvent(element) {
      const panel = element;
     panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
   }

  setScroll(){
    const element= document.getElementById(this.scroll.id);
      if(element){     
        this.registerPanelScrollEvent(element);
      }
    }
}
